export const DISABLED_ASSET_FIELD = 'DISABLED_ASSET_FIELD'

export const ASSET_REQUESTS_LOAD = 'ASSET_REQUESTS_LOAD'
export const ASSET_REQUESTS_LOAD_FULFILLED = 'ASSET_REQUESTS_LOAD_FULFILLED'
export const ASSET_REQUESTS_LOAD_REJECTED = 'ASSET_REQUESTS_LOAD_REJECTED'

export const ASSET_REQUESTS_CREATE = 'ASSET_REQUESTS_CREATE'
export const ASSET_REQUESTS_CREATE_PENDING = 'ASSET_REQUESTS_CREATE_PENDING'
export const ASSET_REQUESTS_CREATE_FULFILLED = 'ASSET_REQUESTS_CREATE_FULFILLED'
export const ASSET_REQUESTS_CREATE_REJECTED = 'ASSET_REQUESTS_CREATE_REJECTED'

export const ASSET_REQUESTS_UPDATE = 'ASSET_REQUESTS_UPDATE'
export const ASSET_REQUESTS_UPDATE_PENDING = 'ASSET_REQUESTS_UPDATE_PENDING'
export const ASSET_REQUESTS_UPDATE_FULFILLED = 'ASSET_REQUESTS_UPDATE_FULFILLED'
export const ASSET_REQUESTS_UPDATE_REJECTED = 'ASSET_REQUESTS_UPDATE_REJECTED'

// employee asset clear requests
export const EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD = 'EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD'
export const EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_PENDING =
  'EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_PENDING'
export const EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_FULFILLED =
  'EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_FULFILLED'
export const EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_REJECTED =
  'EMPLOYEE_ASSET_CLEAR_REQUESTS_NEW_LOAD_REJECTED'

export const ASSET_CLEAR_REQUESTS_CREATE = 'ASSET_CLEAR_REQUESTS_CREATE'
export const ASSET_CLEAR_REQUESTS_CREATE_FULFILLED = 'ASSET_CLEAR_REQUESTS_CREATE_FULFILLED'
export const ASSET_CLEAR_REQUESTS_CREATE_PENDING = 'ASSET_CLEAR_REQUESTS_CREATE_PENDING'
export const ASSET_CLEAR_REQUESTS_CREATE_REJECTED = 'ASSET_CLEAR_REQUESTS_CREATE_REJECTED'

export const ASSET_CLEAR_REQUESTS_UPDATE = 'ASSET_CLEAR_REQUESTS_UPDATE'
export const ASSET_CLEAR_REQUESTS_UPDATE_FULFILLED = 'ASSET_CLEAR_REQUESTS_UPDATE_FULFILLED'
export const ASSET_CLEAR_REQUESTS_UPDATE_PENDING = 'ASSET_CLEAR_REQUESTS_UPDATE_PENDING'
export const ASSET_CLEAR_REQUESTS_UPDATE_REJECTED = 'ASSET_CLEAR_REQUESTS_UPDATE_REJECTED'
